import React from "react";

/**
 * Segmented control to switch a surface (Discover / Evaluate) between the
 * VC-backed corpus and the revenue-first Bootstrapped (TrustMRR) corpus.
 */
export const CorpusToggle = ({ value, onChange, testid = "corpus" }) => {
  const opts = [
    { key: "vc", label: "VC-backed" },
    { key: "bootstrapped", label: "💰 Bootstrapped" },
  ];
  return (
    <div
      className="inline-flex items-center gap-1 p-1 rounded-full border border-zinc-200 bg-white shadow-sm"
      data-testid={`${testid}-corpus-toggle`}
    >
      {opts.map((o) => (
        <button
          key={o.key}
          onClick={() => onChange(o.key)}
          data-testid={`${testid}-corpus-${o.key}`}
          className={`px-4 py-1.5 rounded-full text-[13px] font-semibold transition-colors ${
            value === o.key
              ? "bg-zinc-900 text-white"
              : "text-zinc-500 hover:text-zinc-900"
          }`}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
};

export default CorpusToggle;
